import { useRef, useState } from 'react';
import {
    Button,
    Flag,
    LanguageSwitcher as LanguageSwitcherDialog,
    LanguageSwitcherItem,
    LanguageSwitcherRegion,
} from '@flixbus/honeycomb-react';
import { useTranslation } from 'react-i18next';
import { languagesList, toLangTag } from '../../locale/languagesList';
import { useGlobalLanguage } from '../../hooks/useGlobalLanguage';

const LanguageFlag = ({ language }) => <Flag countryCode={language.flagCode} countryName={language.country} />;

// Header button that opens the honeycomb language selection dialog.
const LanguageSwitcher = () => {
    const { t } = useTranslation();
    const [language, setLanguage] = useGlobalLanguage();
    const [active, setActive] = useState(false);
    const targetRef = useRef();
    const activeLanguage = languagesList[language] ?? languagesList.en;

    const selectLanguage = (code) => {
        setLanguage(code);
        setActive(false);
    };

    return (
        <>
            <Button
                innerRef={targetRef}
                appearance="link"
                noWrap
                aria-haspopup="dialog"
                onClick={() => setActive(true)}
            >
                <LanguageFlag language={activeLanguage} />
                {activeLanguage.title}
            </Button>
            <LanguageSwitcherDialog
                active={active}
                aria-label={t('titles.language')}
                closeLabel={t('buttons.cancel')}
                close={() => setActive(false)}
                targetRef={targetRef}
            >
                <LanguageSwitcherRegion title={t('titles.language')}>
                    {Object.values(languagesList).map((lang) => (
                        <LanguageSwitcherItem
                            key={lang.code}
                            Elem="button"
                            lang={toLangTag(lang.code)}
                            active={lang.code === activeLanguage.code}
                            flag={<LanguageFlag language={lang} />}
                            onClick={() => selectLanguage(lang.code)}
                        >
                            {lang.title}
                        </LanguageSwitcherItem>
                    ))}
                </LanguageSwitcherRegion>
            </LanguageSwitcherDialog>
        </>
    );
};

export default LanguageSwitcher;
